function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M11.5933 22.9997V9.53336H17.2837C17.8947 9.53336 18.4549 9.6598 18.9641 9.91269C19.486 10.1656 19.9316 10.5007 20.3008 10.9179C20.6699 11.3225 20.9564 11.7904 21.1601 12.3215C21.3765 12.8399 21.4847 13.371 21.4847 13.9147C21.4847 14.4837 21.3828 15.0337 21.1791 15.5648C20.9882 16.0832 20.7145 16.551 20.358 16.9683C20.0016 17.3729 19.5688 17.7017 19.0596 17.9546C18.5631 18.1948 18.0093 18.3149 17.3983 18.3149H13.7319V22.9997H11.5933ZM13.7319 16.4372H17.2646C17.5701 16.4372 17.8438 16.374 18.0857 16.2476C18.3403 16.1211 18.5567 15.9441 18.7349 15.7165C18.9132 15.4889 19.0532 15.2234 19.155 14.9199C19.2569 14.6164 19.3078 14.2814 19.3078 13.9147C19.3078 13.5353 19.2505 13.1939 19.1359 12.8905C19.0214 12.587 18.8622 12.3278 18.6586 12.1128C18.4549 11.8852 18.2194 11.7145 17.952 11.6007C17.6974 11.4743 17.4301 11.4111 17.15 11.4111H13.7319V16.4372Z",
  fill: "#979797"
}), React.createElement("path", {
  d: "M16.3668 8.58668H10.6382V14.2767H8.72862V8.58668H3V6.69001H8.72862V1H10.6382V6.69001H16.3668V8.58668Z",
  fill: "#979797"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/DashboardIcon.50e6de7d.svg";
export { SvgComponent as ReactComponent };